module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierdaDerecha-di-90f2ab48.png";